module.exports = __webpack_public_path__ + "img/interior.681a874e.jpg";